import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const dashboardViewEmbedRoute: InvariantJiraRoute = {
	name: 'dashboard-view-embed',
	path: '/jira/dashboards/:dashboardId(\\d+)/embed',
	query: [],
	exact: true,
};
